import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { onHandleNFTMarketIssueAction } from '../utils/actions/nftMarketIssue';
import { onHandleNFTMarketMultipleIssueAction } from '../utils/actions/nftMarketMultipleIssue';
import { symbolNft } from '../config/config';
import { NFT_INVENTORY} from '../config/inventory'
import { validateUsername } from '../utils/hiveLogic';
import './Administrator.scss';


export const Administrator = () => {
    const keychain = window.hive_keychain;
    const UserState = useSelector((store) => store.user);
    const [collectionName, setCollection] = useState(symbolNft);
    const [state, setState] = useState({
        toAccount: 'crypto-shots',
        name: "",
        schema: "",
        img: "",
        description: "",
        count: 1
    });
    const [issuedCounter, setIssuedCounter] = useState(0);

    const handleIssue = async (e) => {
        e.preventDefault();
        const { err } = await validateUsername({ username: state.toAccount });
        if (err) {
            alert(`Incorrect account. Error: ${err}`);
            return;
        }
        try {
            console.log(state);
            if (!state.count || state.count < 1) {
                toast.error("count should be at least 1.");
                return;
            }
            if (!state.toAccount || !state.name || !state.schema || !state.img) {
                alert(`One of ther required fields is missing! ${JSON.stringify({ ...state })}`);
                return;
            }
            if (state.count === 1) {                
                let res = await onHandleNFTMarketIssueAction(keychain, state, UserState.username, collectionName);
                console.log('>>>>res', res);
                toast.success("boadcast to issue the NFT success!")
            } else {
                let res = await onHandleNFTMarketMultipleIssueAction(keychain, state, UserState.username, collectionName);
                console.log('>>>>res', res);
                toast.success("broadcast to issue multiple NFTs success!")
            }
            setIssuedCounter(issuedCounter + state.count);
        } 
        catch (err) {
            console.log(err);
        }   
    }

    const handleChange = (e) => {
        console.log(e.target)
        let { name, value } = e.target;
        if (name === 'count') { value = Math.min(value, 40); }
        setState({
            ...state,
            [name]: value
        })
    }

    const handleSetProperties = (e) => {
      const { name: nameOg } = e.target;
      const { name: nameFallback } = e.currentTarget;
      const name = nameOg || nameFallback;
      try {
        console.log('name', name, NFT_INVENTORY[name]);
        setState({
            ...state,
            name: NFT_INVENTORY[name].name,
            schema : NFT_INVENTORY[name].schema,
            img: NFT_INVENTORY[name].img,
            description: NFT_INVENTORY[name].description,
        });
        setCollection(NFT_INVENTORY[name].collection);
        setIssuedCounter(0);
      } catch (err) {
        alert(name + ' broke to fill fields: ' + JSON.stringify(err));
      }
    }

    return (
        <div className="admin">
            <div className="row">
                <div className="col-3">
                    <h1 className="text-white text-center mt-1">Administrator</h1>
                </div>                
                <div className="col-3 mt-2">
                    <div className="text-center btn-send">
                        <h5 className='text-white black-panel'>Admin account : {UserState.username} </h5>
                    </div>
                </div>
            </div>

            <div className="row container col-12 text-white black-panel">
                <div className="col-4 mb-2" style={{ padding: '20px' }}>
                    <form onSubmit={handleIssue}>
                        <h2 className='mb-2'>Issue NFT</h2><br/>
                        <div className="row">
                            <div className="col-3">
                                <p>to :</p>
                            </div>
                            <div className="col-9">
                                <input type="text" className='form-control form-control-sm' name="toAccount" value={state.toAccount} onChange={handleChange} />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-3">
                                <p>name :</p>
                            </div>
                            <div className="col-9">
                                <input type="text" className='form-control form-control-sm' name="name" value={state.name} onChange={handleChange} />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-3">
                                <p>schema :</p>
                            </div>
                            <div className="col-9">
                                <input type="text" className='form-control form-control-sm' name="schema" value={state.schema} onChange={handleChange} />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-3">
                                <p>img :</p>
                            </div>
                            <div className="col-9">
                                <input type="text" className='form-control form-control-sm' name="img" value={state.img} onChange={handleChange} />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-3">
                                <p>description :</p>
                            </div>
                            <div className="col-9">
                                <input type="text" className='form-control form-control-sm' name="description" value={state.description} onChange={handleChange} />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-3">
                                <p>count :</p>
                            </div>
                            <div className="col-9">
                                <input type="number" min={1} max={40} className='form-control form-control-sm' name="count" value={state.count} onChange={handleChange} />
                            </div>
                        </div>
                        <br/>
                        <button type="submit" disabled={!state.toAccount} style={{ color: 'black' }}>
                            Issue
                        </button> {state.description && <span>&nbsp; {state.count}x &nbsp; &nbsp;</span>}
                        {state.img && <img src={`https://gateway.pinata.cloud/ipfs/${state.img}`} alt="preview" height="80" className="text-right"/>}
                        {state.description && <span> - collection: {collectionName}</span>}
                        {issuedCounter > 0 && <p>Total issued: {issuedCounter}</p>}
                    </form>
                </div>
                <div className="col-4"><br/>
                    <div className="level-items col-9">
                        <b className="col-12">level0.packs</b>
                        <button onClick={handleSetProperties} name="STARTER_PACK" className="ml-3">Starter Pack</button>
                        <button onClick={handleSetProperties} name="MYTHIC_PACK" className="ml-3">Mythic Pack</button>
                        <div style={{ marginTop: '20px' }}>
                            <b className="col-12">game.weapons</b>
                            <button onClick={handleSetProperties} name="BASE_GUN" className="ml-3">Base Gun</button>
                            <button onClick={handleSetProperties} name="LASER_RIFLE" className="ml-3">Rifle</button>
                            <button onClick={handleSetProperties} name="LASER_SHOTGUN" className="ml-3">Shotgun</button>
                        </div>
                        <div style={{ marginTop: '10px' }}>
                            <b className="col-12">game.characters</b>
                            <button onClick={handleSetProperties} name="VANCE_TYRRELL" className="ml-3">Vance Tyrrell</button>
                            <button onClick={handleSetProperties} name="MASHA_TALASHOVA" className="ml-3">Masha Talashova</button>
                        </div>
                    </div>
                    <h2>--------------------------------</h2>
                    <b className="col-12">game.items</b><br/>
                    <div style={{ marginTop: '10px' }}>
                        <button onClick={handleSetProperties} name="FORCE_FIELD_L0" className="ml-3">Force Field 1st lev</button>
                        <button onClick={handleSetProperties} name="FORCE_FIELD" className="ml-3">Force Field 2nd lev</button>
                        <button onClick={handleSetProperties} name="FORCE_FIELD_L2" className="ml-3">Force Field 3rd lev</button>
                        <br/><br/>
                        <button onClick={handleSetProperties} name="TORCH" className="ml-3">Torch Attachment</button>
                    </div>
                    <h2>--------------------------------</h2>
                    <b className="col-12">game.ammo</b>
                    <button onClick={handleSetProperties} name="LEGENDARY_AMMO" className="ml-3">Legendary Ammo</button>
                    <button onClick={handleSetProperties} name="MYTHIC_AMMO" className="ml-3">Mythic Ammo</button>
                    <h2>--------------------------------</h2>
                    <div className="special-events col-9">
                        <b className="col-12">weapon.skins</b><br/><br/>
                        <button onClick={handleSetProperties} name="ELEKTRA_L2_SKIN" className="ml-3">Skin for Elektra</button>
                        <button onClick={handleSetProperties} name="JUSTICE_L2_SKIN" className="ml-3">Skin for Justice</button>
                        <button onClick={handleSetProperties} name="UTOPIA_L2_SKIN" className="ml-3">Skin for Utopia</button>
                    </div>
                    <h2>--------------------------------</h2>
                </div>
                <div className="col-4">
                    <div className="girls">
                        <b className="col-12">cs.cybergirl</b>
                        <br/><b className="col-12">KIARA</b><br/>
                        <button onClick={handleSetProperties} name="KIARA_JANUARY" className="ml-3"><sub>KIARA - January</sub></button>
                        <button onClick={handleSetProperties} name="KIARA_FEBRUARY" className="ml-3"><sub>KIARA - February</sub></button>
                        <button onClick={handleSetProperties} name="KIARA_MARCH" className="ml-3"><sub>KIARA - March</sub></button>
                        <button onClick={handleSetProperties} name="KIARA_APRIL" className="ml-3"><sub>KIARA - April</sub></button>
                        <button onClick={handleSetProperties} name="KIARA_MAY" className="ml-3"><sub>KIARA - May</sub></button><br/>
                        <button onClick={handleSetProperties} name="KIARA_JUNE" className="ml-3"><sub>KIARA - June</sub></button>
                        <button onClick={handleSetProperties} name="KIARA_JULY" className="ml-3"><sub>KIARA - July</sub></button>
                        <button onClick={handleSetProperties} name="KIARA_AUGUST" className="ml-3"><sub>KIARA - August</sub></button>
                        <button onClick={handleSetProperties} name="KIARA_SEPTEMBER" className="ml-3"><sub>KIARA - September</sub></button>
                        <button onClick={handleSetProperties} name="KIARA_OCTOBER" className="ml-3"><sub>KIARA - October</sub></button><br/>
                        <button onClick={handleSetProperties} name="KIARA_NOVEMBER" className="ml-3"><sub>KIARA - November</sub></button>
                        <button onClick={handleSetProperties} name="KIARA_DECEMBER" className="ml-3"><sub>KIARA - December</sub></button>
                        <br/><b className="col-12">KARINA</b><br/>
                        <button onClick={handleSetProperties} name="KARINA_JANUARY" className="ml-3"><sub>KARINA - January</sub></button>
                        <button onClick={handleSetProperties} name="KARINA_FEBRUARY" className="ml-3"><sub>KARINA - February</sub></button>
                        <button onClick={handleSetProperties} name="KARINA_MARCH" className="ml-3"><sub>KARINA - March</sub></button>
                        <button onClick={handleSetProperties} name="KARINA_APRIL" className="ml-3"><sub>KARINA - April</sub></button>
                        <button onClick={handleSetProperties} name="KARINA_MAY" className="ml-3"><sub>KARINA - May</sub></button><br/>
                        <button onClick={handleSetProperties} name="KARINA_JUNE" className="ml-3"><sub>KARINA - June</sub></button>
                        <button onClick={handleSetProperties} name="KARINA_JULY" className="ml-3"><sub>KARINA - July</sub></button>
                        <button onClick={handleSetProperties} name="KARINA_AUGUST" className="ml-3"><sub>KARINA - August</sub></button>
                        <button onClick={handleSetProperties} name="KARINA_SEPTEMBER" className="ml-3"><sub>KARINA - September</sub></button>
                        <button onClick={handleSetProperties} name="KARINA_OCTOBER" className="ml-3"><sub>KARINA - October</sub></button><br/>
                        <button onClick={handleSetProperties} name="KARINA_NOVEMBER" className="ml-3"><sub>KARINA - November</sub></button>
                        <button onClick={handleSetProperties} name="KARINA_DECEMBER" className="ml-3"><sub>KARINA - December</sub></button>
                        <br/><b className="col-12">MARTE</b><br/>
                        <button onClick={handleSetProperties} name="MARTE_JANUARY" className="ml-3"><sub>MARTE - January</sub></button>
                        <button onClick={handleSetProperties} name="MARTE_FEBRUARY" className="ml-3"><sub>MARTE - February</sub></button>
                        <button onClick={handleSetProperties} name="MARTE_MARCH" className="ml-3"><sub>MARTE - March</sub></button>
                        <button onClick={handleSetProperties} name="MARTE_APRIL" className="ml-3"><sub>MARTE - April</sub></button>
                        <button onClick={handleSetProperties} name="MARTE_MAY" className="ml-3"><sub>MARTE - May</sub></button><br/>
                        <button onClick={handleSetProperties} name="MARTE_JUNE" className="ml-3"><sub>MARTE - June</sub></button>
                        <button onClick={handleSetProperties} name="MARTE_JULY" className="ml-3"><sub>MARTE - July</sub></button>
                        <button onClick={handleSetProperties} name="MARTE_AUGUST" className="ml-3"><sub>MARTE - August</sub></button>
                        <button onClick={handleSetProperties} name="MARTE_SEPTEMBER" className="ml-3"><sub>MARTE - September</sub></button>
                        <button onClick={handleSetProperties} name="MARTE_OCTOBER" className="ml-3"><sub>MARTE - October</sub></button><br/>
                        <button onClick={handleSetProperties} name="MARTE_NOVEMBER" className="ml-3"><sub>MARTE - November</sub></button>
                        <button onClick={handleSetProperties} name="MARTE_DECEMBER" className="ml-3"><sub>MARTE - December</sub></button>
                    </div>
                    <h2>--------------------------------</h2>
                    <div className="girls">
                        <b className="col-12">early.access</b>
                        <br/><b className="col-12">PVP PASS</b><br/>
                        <button onClick={handleSetProperties} name="PVP_ALPHA_PASS" className="ml-3"><sub>PVP ALPHA PASS</sub></button>
                    </div>
                </div>
                <div className="col-7 row level-items">
                    <div className="col-1">
                      <h5>2nd LEVEL</h5>
                    </div>
                    <div className="col-4 row" style={{ marginLeft: '10px' }}>
                      <b className="col-12" style={{ marginBottom: '10px' }}>level1.packs</b>
                      <button onClick={handleSetProperties} name="LEV_1_PACK_COMMON" className="ml-3">L2 COMM PACK</button>
                      <button onClick={handleSetProperties} name="LEV_1_PACK_EPIC" className="ml-3">L2 EPIC PACK</button>
                    </div>
                    <div className="col-4 row" style={{ marginLeft: '20px' }}>
                      <b className="col-12" style={{ marginBottom: '10px' }}>game.weapons</b>
                      <div>
                        <button onClick={handleSetProperties} name="SAVAGE" className="ml-3 col-3">SAVAGE</button>
                        <button onClick={handleSetProperties} name="TREMOR" className="ml-3 col-3">TREMOR</button>
                        <button onClick={handleSetProperties} name="VORTEX" className="ml-3 col-3">VORTEX</button>
                      </div>
                    </div>
                    <div className="col-3 row" style={{ marginLeft: '10px' }}>
                      <b style={{ marginLeft: '20px' }}>game.characters</b>
                      <div>
                        <button onClick={handleSetProperties} name="IVAN_BARRICK" className="ml-4 col-4">IVAN</button>
                        <button onClick={handleSetProperties} name="MINTA_HANI" className="ml-5 col-4">MINTA</button>
                      </div>
                    </div>
                </div>
                <div className="col-7 row mt-4 level-items">
                    <div className="col-1">
                      <h5>3rd LEVEL</h5>
                    </div>
                    <div className="col-4 row" style={{ marginLeft: '10px' }}>
                      <b className="col-12" style={{ marginBottom: '10px' }}>level2.packs</b>
                      <button onClick={handleSetProperties} name="LEV_2_PACK_COMMON" className="ml-3">L3 COMMON PACK</button>
                      <button onClick={handleSetProperties} name="LEV_2_PACK_RARE" className="ml-3">L3 RARE PACK</button>
                    </div>
                    <div className="col-4 row" style={{ marginLeft: '20px' }}>
                      <b className="col-12" style={{ marginBottom: '10px' }}>game.weapons</b>
                      <button onClick={handleSetProperties} name="MURAN" className="ml-3 col-3">MURAN</button>
                      <button onClick={handleSetProperties} name="THETA" className="ml-3 col-3">THETA</button>
                      <button onClick={handleSetProperties} name="VENGA" className="ml-3 col-3">VENGA</button>
                    </div>
                    <div className="col-3">
                      <b className="col-12" style={{ marginBottom: '10px' }}>game.characters</b>
                      <button onClick={handleSetProperties} name="LEXI_CAYNE" className="ml-3 col-4">LEXI</button>
                      <button onClick={handleSetProperties} name="EVELYN_MOORE" className="ml-3 col-4">EVELYN</button>
                    </div>
                </div>
                <br/><br/>
            </div>
        </div>
    );
}
